import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";

const CheckboxGroup = ({ title, options, onChange }) => {
  //state to store the value
  const [value, setValue] = React.useState(
    options.reduce((acc, option) => {
      acc[option] = false;
      return acc;
    }, {})
  );

  const handleChange = (event) => {
    const newValue = {
      ...value,
      [event.target.name]: event.target.checked,
    };
    setValue(newValue);
    // create array of true values
    const selectedOptions = Object.keys(newValue).filter(
      (option) => newValue[option]
    );
    onChange(selectedOptions);
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={value[option]}
                onChange={handleChange}
                name={option}
              />
            }
            label={option}
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default CheckboxGroup;
